export default "__VITE_ASSET__uVs3t8EF__"